module.exports = __webpack_public_path__ + "img/hd.7bbfa0fe.png";